import { render, staticRenderFns } from "./LoadMoreTaskInColumnBtn.vue?vue&type=template&id=0b2493fa&scoped=true"
import script from "./LoadMoreTaskInColumnBtn.vue?vue&type=script&lang=js"
export * from "./LoadMoreTaskInColumnBtn.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreTaskInColumnBtn.vue?vue&type=style&index=0&id=0b2493fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2493fa",
  null
  
)

export default component.exports